<template>
  <section class="tw:py-6 tw:lg:py-8">
    <div
      class="tw:lg:max-w-(--tw-breakpoint-landing) tw:lg:mx-auto tw:lg:grid tw:grid-cols-[535px_auto] tw:lg:place-content-between"
    >
      <div
        class="tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:mx-auto tw:mb-4 tw:lg:mb-0 tw:flex tw:flex-col tw:md:grid tw:md:grid-cols-2 tw:lg:grid-cols-1 tw:lg:grid-rows-[max-content_auto] tw:gap-4 tw:md:gap-8 tw:lg:gap-4 tw:md:items-center tw:lg:items-start"
      >
        <div class="tw:px-6 tw:md:px-0 tw:md:order-2 tw:lg:order-first">
          <img
            :src="RateConnectLogo"
            alt="Rate Connect"
            class="tw:w-[183px] tw:md:w-[203px] tw:lg:w-[280px] tw:mx-auto tw:md:mx-0"
          />
          <h3
            class="tw:font-bold tw:lg:text-header-big tw:text-xl tw:md:text-2xl tw:mt-2 tw:text-center tw:md:text-left"
            :class="{ 'tw:lg:hidden': currentCardId }"
            v-html="$t('rc_mp_overview_header')"
          />
          <p
            class="tw:text-center tw:md:text-left tw:text-xs tw:sm:text-sm tw:lg:text-xl tw:mt-4 tw:md:mt-2 tw:md:mb-0"
            :class="{ 'tw:lg:hidden': currentCardId }"
          >
            {{ $t('rc_mp_overview_subtext') }}
          </p>
        </div>
        <div v-show="currentCardId">
          <img
            v-if="currentCardId"
            class="tw:md:hidden tw:w-full tw:md:h-[446px] tw:px-6 tw:md:px-0 tw:md:order-1 tw:lg:order-2"
            :src="cards[currentCardIndex].img"
          />
          <div class="tw:hidden tw:md:block tw:h-[270px] tw:lg:h-[497px]">
            <video
              v-if="currentCardId && !isMobile"
              ref="videoRef"
              autoplay
              muted
              loop
              width="1070"
              height="996"
              :key="currentCardId"
              :src="cards[currentCardIndex].vid"
              @click="togglePlay"
              class="tw:object-contain tw:cursor-pointer tw:max-h-[270px] tw:lg:max-h-none"
            />
          </div>
        </div>
        <div
          v-show="!currentCardId"
          class="tw:hidden tw:md:block tw:rounded-xl tw:border tw:border-black line-shadow tw:h-[270px] tw:lg:h-[374px] tw:w-full rc_image"
        />
      </div>
      <div class="tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:mx-auto">
        <RateConnectBenefitsCards :cards="cards" :currentCardId="currentCardId" @onCardClicked="setCurrentCard" />
        <RateConnectBenefitsCardsMobile :cards="cards" @onCardChanged="setCurrentCard" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'

import RateConnectBenefitsCardsMobile from '@/components/productPage/rateConnect/benefits/RateConnectBenefitsCardsMobile.vue'
import RateConnectBenefitsCards from '@/components/productPage/rateConnect/benefits/RateConnectBenefitsCards.vue'
import commissionAllImg from '@/assets/img/rate-connect-landing/benefits/rc_benefits_commission_all.png'
import visibilityImg from '@/assets/img/rate-connect-landing/benefits/rc_benefits_visibility.png'
import trackPerformanceImg from '@/assets/img/rate-connect-landing/benefits/rc_benefits_track_performance.png'
import globalReachImg from '@/assets/img/rate-connect-landing/benefits/rc_benefits_global_reach.png'
import commissionAllVid from '@/assets/videos/rate-connect-landing/benefits/rc_benefits_commission_all.mp4'
import globalReachVid from '@/assets/videos/rate-connect-landing/benefits/rc_benefits_global_reach.mp4'
import performanceVid from '@/assets/videos/rate-connect-landing/benefits/rc_benefits_performance.mp4'
import visibilityVid from '@/assets/videos/rate-connect-landing/benefits/rc_benefits_visibility.mp4'
import { useIsMobile } from '@/composables/useIsMobile'

const RateConnectLogo = new URL('/src/assets/img/landing/landing_rate_connect.svg', import.meta.url)

const { isMobile } = useIsMobile()
const currentCardId = ref('')
const cards = computed(() => [
  {
    id: 'sliderc_0',
    title: 'rc_mp_overview_benefit_1_header',
    text: 'rc_mp_overview_benefit_1_text',
    img: commissionAllImg,
    vid: commissionAllVid,
  },
  {
    id: 'sliderc_1',
    title: 'tbs_mp_rc_benefits_2',
    text: 'tbs_mp_rc_benefits_2_text',
    img: visibilityImg,
    vid: visibilityVid,
  },
  {
    id: 'sliderc_2',
    title: 'tbs_mp_rc_benefits_4',
    text: 'tbs_mp_rc_benefits_4_text',
    img: trackPerformanceImg,
    vid: performanceVid,
  },
  {
    id: 'sliderc_3',
    title: 'tbs_mp_rc_benefits_5',
    text: 'rc_mp_overview_benefit_3_text',
    img: globalReachImg,
    vid: globalReachVid,
  },
])
const currentCardIndex = computed(() => Number(currentCardId.value.split('_')?.[1]))

const setCurrentCard = ({ id }) => {
  if (!id) return
  currentCardId.value = id
}

const videoRef = ref(null)

const togglePlay = () => {
  if (!videoRef.value) return
  videoRef.value.paused ? videoRef.value.play() : videoRef.value.pause()
}
</script>

<style scoped>
.line-shadow {
  box-shadow: 3px 3px 0px 0px #000;
}

.rc_image {
  background-image: url('../../../assets/img/rate-connect-landing/rate_connect_benefits_img.jpg');
  background-size: cover;
  background-position: center top;
  width: 100%;
}
</style>
